import React from 'react'
import MostyLogo from '../assets/images/logo_mosty.svg'
import '../styles/components/LoginHeader.css'

const LoginHeader = () => {
  return (
    <div className='login-header-container'>
      <img src={MostyLogo} alt='logo' />
    </div>
  )
}

export default LoginHeader



// WEBPACK FOOTER //
// ./src/components/LoginHeader.js